<template>
  <el-drawer
    title="界面设置"
    :visible="visible"
    size="380px"
    append-to-body
    custom-class="theme-settings-drawer"
    @update:visible="$emit('input', $event)">
    <div class="theme-settings">
      <div class="theme-settings__preview">
        <span class="theme-preview-mark"><i class="el-icon-setting" /></span>
        <div><strong>控制台显示偏好</strong><small>设置会保存在当前浏览器</small></div>
      </div>

      <section class="theme-setting-group">
        <label>外观模式</label>
        <el-radio-group :value="preferences.theme" size="small" @input="setPreference('theme', $event)">
          <el-radio-button label="light">浅色</el-radio-button>
          <el-radio-button label="dark">深色</el-radio-button>
          <el-radio-button label="custom">自定义</el-radio-button>
        </el-radio-group>
        <div :class="['theme-color-row', { active: preferences.theme === 'custom' }]">
          <div><strong>自定义底色</strong><small>{{ preferences.customThemeColor }}</small></div>
          <el-color-picker :value="preferences.customThemeColor" :predefine="themeColors" @change="setCustomTheme" />
        </div>
      </section>

      <section class="theme-setting-group">
        <label>强调色</label>
        <div class="theme-accent-grid">
          <button v-for="item in accents" :key="item.value" :class="{ active: preferences.accent === item.value }" type="button" @click="setPreference('accent', item.value)">
            <span :style="{ background: item.color }" /><small>{{ item.label }}</small>
          </button>
        </div>
        <div :class="['theme-color-row', { active: preferences.accent === 'custom' }]">
          <div><strong>自定义强调色</strong><small>{{ preferences.customAccent }}</small></div>
          <el-color-picker :value="preferences.customAccent" :predefine="accentColors" @change="setCustomAccent" />
        </div>
      </section>

      <section class="theme-setting-group theme-font-size-setting">
        <div class="theme-setting-heading">
          <span><strong>界面字号</strong><small>统一调整系统内的文字大小</small></span>
          <em>{{ preferences.fontSize }}px</em>
        </div>
        <el-slider :value="Number(preferences.fontSize)" :min="14" :max="24" :step="1" :marks="fontSizeMarks" show-stops @input="setPreference('fontSize', $event)" />
      </section>

      <section class="theme-setting-group theme-setting-list">
        <div><span><strong>紧凑布局</strong><small>缩小导航与内容间距</small></span><el-switch :value="preferences.compact" @input="setPreference('compact', $event)" /></div>
        <div><span><strong>玻璃效果</strong><small>为面板增加透明和模糊</small></span><el-switch :value="preferences.glass" @input="setPreference('glass', $event)" /></div>
        <div><span><strong>界面动效</strong><small>启用页面切换和悬停过渡</small></span><el-switch :value="preferences.motion" @input="setPreference('motion', $event)" /></div>
      </section>

      <el-button class="theme-settings__reset" icon="el-icon-refresh-left" @click="resetPreferences">恢复默认设置</el-button>
    </div>
  </el-drawer>
</template>

<script>
import { normalizeColor } from '@/utils/preferences'

export default {
  name: 'ThemeSettings',
  props: { value: { type: Boolean, default: false } },
  data() {
    return {
      accents: [
        { value: 'neutral', label: '中性', color: '#64748b' },
        { value: 'blue', label: '蓝色', color: '#2f6fed' },
        { value: 'cyan', label: '青色', color: '#0891b2' },
        { value: 'emerald', label: '翠绿', color: '#059669' },
        { value: 'amber', label: '琥珀', color: '#d97706' },
        { value: 'violet', label: '紫色', color: '#7c3aed' }
      ],
      fontSizeMarks: { 14: '默认', 18: '大', 24: '特大' },
      themeColors: ['#0f172a', '#172033', '#243047', '#f3f5f8', '#eff6ff', '#f4f4f5'],
      accentColors: ['#2f6fed', '#0891b2', '#059669', '#d97706', '#dc2626', '#7c3aed']
    }
  },
  computed: {
    visible() { return this.value },
    preferences() { return this.$store.state.app.preferences }
  },
  methods: {
    setPreference(key, value) { this.$store.commit('app/SET_PREFERENCE', { key, value }) },
    setCustomTheme(color) {
      if (!color) return
      this.$store.commit('app/SET_PREFERENCES', { theme: 'custom', customThemeColor: normalizeColor(color, '#172033') })
    },
    setCustomAccent(color) {
      if (!color) return
      this.$store.commit('app/SET_PREFERENCES', { accent: 'custom', customAccent: normalizeColor(color) })
    },
    resetPreferences() { this.$store.commit('app/RESET_PREFERENCES') }
  }
}
</script>
